import { Link, Palette, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface IMessageMarkdownProps {
  content: string;
  palette: Palette;
}

export const MessageMarkdown: React.FC<IMessageMarkdownProps> = ({
  content,
  palette,
}) => (
  <ReactMarkdown
    remarkPlugins={[remarkGfm]}
    components={{
      p: ({ children }) => (
        <Typography
          variant="body1"
          sx={{ wordWrap: "break-word", whiteSpace: "pre-wrap", m: 0 }}
        >
          {children}
        </Typography>
      ),
      a: ({ href, children }) => (
        <Link href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </Link>
      ),
      ul: ({ children }) => (
        <Typography component="ul" variant="body1" sx={{ pl: 3, m: 0 }}>
          {children}
        </Typography>
      ),
      ol: ({ children }) => (
        <Typography component="ol" variant="body1" sx={{ pl: 3, m: 0 }}>
          {children}
        </Typography>
      ),
      li: ({ children }) => (
        <Typography component="li" variant="body1">
          {children}
        </Typography>
      ),
      code: ({ inline, children, ...props }: any) =>
        inline ? (
          <Typography
            component="code"
            sx={{
              fontFamily: "monospace",
              fontSize: "0.85em",
              borderRadius: 0.5,
              px: 1,
              py: 0.5,
              backgroundColor:
                palette.mode === "dark" ? palette.grey[800] : palette.grey[200],
            }}
            {...props}
          >
            {children}
          </Typography>
        ) : (
          <Typography
            component="pre"
            sx={{
              fontFamily: "monospace",
              fontSize: "0.85em",
              borderRadius: 1,
              p: 1.5,
              overflowX: "auto",
              whiteSpace: "pre",
              backgroundColor:
                palette.mode === "dark" ? palette.grey[900] : palette.grey[100],
            }}
            {...props}
          >
            <code>{children}</code>
          </Typography>
        ),
      table: ({ children }) => (
        <Typography
          component="table"
          variant="body1"
          sx={{
            borderCollapse: "collapse",
            width: "100%",
            my: 1,
            "& th, & td": {
              border: `1px solid ${palette.text.borderLine}`,
              p: 1,
              textAlign: "left",
            },
            "& th": {
              backgroundColor: palette.text.input,
              fontWeight: 600,
            },
          }}
        >
          {children}
        </Typography>
      ),
    }}
  >
    {content}
  </ReactMarkdown>
);
